import ExportExcelEug from './exportExcelEug'

const components = [
  ExportExcelEug
]

export default components



// WEBPACK FOOTER //
// ./src/components/index.js